module.exports = __webpack_public_path__ + "static/media/Manual_Maker_App_Screen_Product.42b3d2cd.png";